// extracted by mini-css-extract-plugin
export default {"logo":"LogoType_logo__wc+d8","logoDark":"LogoType_logoDark__4sIpy","logoLight":"LogoType_logoLight__edB6s","collapsed":"LogoType_collapsed__4ETs7"};